export const getAppHead = ({ host }) => {
  if (host.includes('musclecharge.app'))
    return {
      title: 'Muscle Charge',
      meta: [
        { hid: 'og:url', property: 'og:url', content: 'https://musclecharge.app' },
        { hid: 'og:title', property: 'og:title', content: 'Muscle Charge' },
        {
          hid: 'og:description',
          property: 'og:description',
          content: 'Fitness app for men over 40',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'Discover short and effective fitness plans for men over 40 to support muscle growth, weight loss and energy boost.',
        },
        {
          hid: 'facebook-domain-verification',
          name: 'facebook-domain-verification',
          content: 'omhlur62nh3mcqd5c6s80b9cwjgzk7',
        },
      ],
      link: [
        { hid: 'favicon-muscle-charge', rel: 'icon', type: 'image/x-icon', href: '/favicon.muscle-charge.ico' },
        {
          hid: 'typekit-muscle-charge',
          rel: 'stylesheet',
          href: 'https://use.typekit.net/cxe5rvi.css',
        },
      ],
    };

  return {
    title: 'Reverse Health',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          "Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology",
      },
      { hid: 'og:url', property: 'og:url', content: 'https://reverse.health' },
      { hid: 'og:title', property: 'og:title', content: 'Reverse Health' },
      {
        hid: 'og:description',
        property: 'og:description',
        content:
          "Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology.",
      },
      {
        hid: 'facebook-domain-verification',
        name: 'facebook-domain-verification',
        content: 'pbnzferzi10qee09g49f28pcvhvgbz',
      },
    ],
    link: [{ hid: 'favicon', rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  };
};
